// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"c72de1fd","139":"6503a653"}[chunkId] + ".chunk.js";
};